class SectionMap {

    constructor() {
        var that = this;
        that.markers = [];
        that.container = jQuery(".flex-section-map");

        that.container.on('click', '.block-store', function(e) {
            e.preventDefault();
            var $elt = jQuery(this),
                index_store = $elt.data('id');

            console.log('Click block store = ID : '+index_store);

            if ( $elt.hasClass('-selected') ) return;

            that.container.find('.-selected').removeClass('-selected');
            $elt.addClass('-selected');

            var latLng = that.markers[ index_store ].getPosition();

            that.map.setCenter(latLng);
            that.map.setZoom(12);

            // @todo gestion changement de marker
        });
    }

    init() {
        var that = this;
        that.stores = stores;
        that.map = new google.maps.Map(document.getElementById('map'), {
            center: {lat: 46.52863469527167, lng: 2.43896484375},
            zoom: 5
        });
        $.each(that.stores, function (key, store) {
            var marker = new google.maps.Marker({
                position: {lat: store.lat, lng: store.lng},
                map: that.map,
                title: store.title
            });
            that.markers.push( marker );
        });
    }
}

var class_stores = new SectionMap();

function initMap() {
    class_stores.init(stores);
}

